"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.7071068,2.29211502 L20.7035288,10.288537 L19.2893152,11.7027506 L12.9994712,5.4122218 L13,22.0007782 L11,22.0007782 L10.9994712,5.4122218 L4.71068475,11.7027506 L3.29647119,10.288537 L11.2928932,2.29211502 C11.6834175,1.90159073 12.3165825,1.90159073 12.7071068,2.29211502 Z"
  });
}.bind(void 0));

exports.default = _default;